module.exports = __webpack_public_path__ + "static/img/fuweiguo.92d9d15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/fuweiguo.png
// module id = jYav
// module chunks = 4